import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import { ApiService } from '../http/api.service';
import { environment } from 'src/environments/environment';
import { getHeaders } from '../http/modal/header';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  userData;
  lovData;
  user: Subject<object> = new BehaviorSubject<object>(null);
  constructor(
    private readonly us: UtilityService,
    private readonly apiService: ApiService
  ) { }

  getUserData() {
    return this.userData;
  }

  getLovData() {
    return this.lovData;
  }

  setLovData(data) {
    this.lovData = data;
  }

  setUserData(data) {
    this.userData = data;
  }

  userSubject(data) {
    this.user.next(data);
  }
  profileLovData() {
    const path = '/utility/user/static-data';
    return this.apiService.get(`${environment.cloudUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  addUser(data) {
    const path = '/user/invite';
    return this.apiService.post(`${environment.url}${path}`, data, {
      headers: getHeaders(),
    });
  }

  updateUser(data) {
    const path = `/user/profile`;
    return this.apiService.put(`${environment.updateProfileUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  changeUserPassword(data) {
    const path = `/user/change-password`;
    return this.apiService.put(`${environment.changePasswordUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  getUserById() {
    const path = `/user?userId=${this.us.getUserId()}`;
    return this.apiService.get(`${environment.url}${path}`, {
      headers: getHeaders(),
    });
  }

  uploadImage(data) {
    const path = '/utility/upload';
    return this.apiService.post(`${environment.cloudUrl}${path}`, data, {
      headers: getHeaders(true),
    });
  }

  getOtp(data) {
    const path = '/api/v1/mobile/send-verification-link';
    return this.apiService.post(`${environment.identityUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  sendOtp(data){
    const path = `/api/v1/mobile/send-mobile-otp?to=${data.mobileNumber}&otp=${data.otp}`;
    return this.apiService.get(`${environment.identityUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  verifyOtp(data) {
    //actual
    const path = `/member/verify?${data}`;
    return this.apiService.get(`${environment.identityUrl}${path}`, {
      headers: getHeaders(),
    });
  }

  twoStepVerification(data) {
    const path = `/user/two-step-verification?userId=${this.us.getUserId()}`;
    return this.apiService.put(`${environment.updateProfileUrl}${path}`, data, {
      headers: getHeaders(),
    });
  }

  updateSecurity(data) {
    const path = `/user/security-questions?userId=${this.us.getUserId()}`;
    return this.apiService.put(`${environment.url}${path}`, data, {
      headers: getHeaders(),
    });
  }
}
